import axios, { HttpStatusCode } from "axios";

const axiosHttp = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

let accessToken = null;

export const setAuthToken = (token) => {
  accessToken = token;
};


// Request Interceptor (Optional)
axiosHttp.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    // Use either the state variable or localStorage
    const activeToken = accessToken || token;

    if (activeToken) {
      config.headers.Authorization = `Bearer ${activeToken}`;
      config.headers["x-access-token"] = activeToken;
      config.headers["user_id"] = userId;
    }
    return config;
  },
  (error) => {
    return Promise.reject({
      message: "Request error occurred",
      status: HttpStatusCode.InternalServerError,
      ...(error?.request || {}),
    });
  }
);

// Response Interceptor
axiosHttp.interceptors.response.use(
  (response) => {
    const newToken = response?.headers?.["x-access-token"];
    if (newToken) {
      setAuthToken(newToken);
      localStorage.setItem("token", newToken);
    }

    if (response.status >= HttpStatusCode.Ok && response.status <= 299) {
      return (
        response.data || {
          error: false,
          data: [],
          message: "",
        }
      );
    } else {
      const errorData = response?.data || {
        error: true,
        status: response.status,
        data: [],
        message: "API error occurred",
      };
      return Promise.reject(errorData);
    }
  },
  async (error) => {
    // Vault lock expired/invalid → drop the stale unlock token so the vault re-prompts.
    if (error.response?.data?.vaultLocked) sessionStorage.removeItem("vaultToken");

    // Auto-refresh token on 401 Unauthorized
    if (error.response?.status === 401 && !error.config?._retry) {
      error.config._retry = true;
      try {
        const storedToken = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");
        const refreshRes = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/lmt/refresh`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
              "x-access-token": storedToken,
              user_id: userId,
            },
          }
        );
        const newToken = refreshRes?.data?.accessToken;
        if (newToken) {
          setAuthToken(newToken);
          localStorage.setItem("token", newToken);
          error.config.headers.Authorization = `Bearer ${newToken}`;
          error.config.headers["x-access-token"] = newToken;
          error.config.headers["user_id"] = userId;
          return axiosHttp(error.config);
        }
      } catch (refreshErr) {
        console.error("Auto refresh on 401 failed:", refreshErr);
      }
    }

    const backendMessage = error.response?.data?.message || error.response?.data?.error || "Response error occurred";
    return Promise.reject({
      message: backendMessage,
      status: error.response?.status || HttpStatusCode.InternalServerError,
      ...(error?.response || {}),
    });
  }
);

export default axiosHttp;
